/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PostAssignmentDataSourceProbePathParams = NonNullable<
  operations['postAssignmentDataSourceProbe']['parameters']['path']
>;

export type PostAssignmentDataSourceProbeRequestBody = OperationRequestBodyContent<
  operations['postAssignmentDataSourceProbe']
>;

export interface Input extends PostAssignmentDataSourceProbePathParams {
  apiVersion?: string;
  body: PostAssignmentDataSourceProbeRequestBody;
}

export async function postAssignmentDataSourceProbe(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().POST('/internal/projects/{projKey}/assignment-data-sources/{dataSourceKey}/probe', {
    params: { path },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
